import {SET_DATA_MODAL_CREATE_LOT} from "../../types";
export function onToggleModal(showModal) {
    return (dispatch) => {
        dispatch({type: SET_DATA_MODAL_CREATE_LOT, payload: {showModal}})
    }
}
